import { Component, EventEmitter, OnInit, Output, ViewChild, inject } from '@angular/core';
import { IndexRebuildService } from '../index-rebuild.service';
import { IndexRebuildStatus } from '../index-rebuild-status';
import { timer, of } from 'rxjs';
import { concatMap, switchMap, takeWhile } from 'rxjs/operators';
import { ModalDirective } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-index-rebuild',
    templateUrl: './index-rebuild.component.html',
    standalone: false
})
export class IndexRebuildComponent implements OnInit {
  private indexResetService = inject(IndexRebuildService);

  step: 'WARNING' | 'PROGRESS' | 'COMPLETE' = 'WARNING';

  status: IndexRebuildStatus;

  @ViewChild('resetIndexModal', { static: true })
  public resetIndexModal: ModalDirective;

  ngOnInit() {}

  show() {
    this.resetIndexModal.show();
  }

  begin() {
    this.indexResetService.resetIndexes().subscribe((status) => {
      this.step = 'PROGRESS';
      this.status = status;

      timer(0, 10000)
        .pipe(
          switchMap((_) => this.indexResetService.getResetStatus()),
          concatMap((status) =>
            status.status === 'Complete' ? of(status, null) : of(status)
          ),
          takeWhile((status) => status !== null)
        )
        .subscribe((status) => {
          this.status = status;
          if (this.status.status === 'Complete') {
            this.step = 'COMPLETE';
          }
        });
    });
  }

  close() {
    this.resetIndexModal.hide();
    if (this.status !== null && this.status.status === 'Complete') {
      this.step = 'WARNING';
    }
  }
}
